module.exports = function () {
  return new Promise(function (resolve) {
    require.ensure([], function (require) {
      resolve(require("!!/Users/diogo/Documents/Projects/releases/release-2022-05-16/metabase/node_modules/babel-loader/lib/index.js??ruleSet[1].rules[0].use[0]!/Users/diogo/Documents/Projects/releases/release-2022-05-16/metabase/frontend/src/metabase/lib/ga-metadata.js"));
    });
  });
}